import { render, staticRenderFns } from "./lab-product.vue?vue&type=template&id=79d07288"
import script from "./lab-product.vue?vue&type=script&lang=js"
export * from "./lab-product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports